import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "showIcon", "hideIcon"]

  toggle() {
    const isPassword = this.inputTarget.type === "password"
    this.inputTarget.type = isPassword ? "text" : "password"
    this.showIconTarget.classList.toggle("d-none", !isPassword)
    this.hideIconTarget.classList.toggle("d-none", isPassword)
  }
}
